<template>
  <div
    :class="$style.card"
    :style="backgroundOptions"
    data-luko-tracking="ColoredCard"
  >
    <Title :title-params="title" :class="$style.title" />
    <RichText :text-params="description" :class="$style.desc" />
    <LkButton :href="formatedButtonLink" is-small :class="$style.button">
      {{ buttonText }}
    </LkButton>
  </div>
</template>

<script>
import linkResolver from '~/utils/prismic/link-resolver'
import Title from '~/components/Title'
import RichText from '~/components/RichText'

export default {
  name: 'ColoredCard',

  components: {
    Title,
    RichText,
  },

  props: {
    title: {
      type: Array,
      default: () => [],
    },
    description: {
      type: Array,
      default: () => [],
    },
    buttonLink: {
      type: Object,
      default: () => ({}),
    },
    buttonText: {
      type: String,
      default: '',
    },
    iconUrl: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },

  computed: {
    backgroundColorHex() {
      switch (this.backgroundColor) {
        case 'gold':
          return '#eec675'

        case 'orange':
          return '#FFEDE3'

        default:
          return ''
      }
    },

    backgroundOptions() {
      return `background-image: url(${this.iconUrl}); background-color: ${this.backgroundColorHex};`
    },

    formatedButtonLink() {
      return linkResolver(this.buttonLink)
    },
  },
}
</script>

<style lang="scss" module>
.card {
  max-width: 252px;
  padding: 24px;
  border-radius: 8px;

  background-repeat: no-repeat;

  background-position: calc(100%) calc(100% + 10px);
  background-size: 100px 100px;
}

.title {
  @include typo-headline;
}

.desc {
  margin-top: 8px;
}

.button {
  margin-top: 32px;
}
</style>
